
import axios from 'axios';
// import { window.API_BASE_URL } from '../config.js';

const initialState = {
    assistants: [],
};

// Action Types
const GET_ASSISTANTS = 'GET_ASSISTANTS';

// Reducer
export default function GPTServiceReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ASSISTANTS:
            return { ...state, assistants: action.payload };
        default:
            return state;
    }
}

// Action Creators
export const GetAssistants = (assistants) => ({
    type: GET_ASSISTANTS,
    payload: assistants,
});

// API Integration Function
export const fetchAssistantsFromAPI = () => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL+'/Assistant/GetAll');
        const data = response.data;
        dispatch(GetAssistants(data));
    } catch (error) {
        console.error('Error fetching assistants:', error);
    }
}
